<template lang="html">
    <entity-page id="page__forward-price" v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>
        <div slot="default">

            <z-select
                label="Тип пункта экспедирования" v-model="price.by" :required="true" name="by" id="by"
                v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('by')" v-on:input="resetType"
            >
                <option value="" selected disabled> Выбрать... </option>
                <option value="city"> Населённый пункт </option>
                <option value="steet"> Улица </option>

            </z-select>

            <z-input-autocomplete
                v-model="price.city_id" v-on:select="selectCity" 
                property="id" return="id" label="Населённый пункт (город/посёлок/село/...)" display-property="label" name="city_id"
                v-bind:callback="getCities" v-bind:default="(price.city && price.city.value) ? price.city.value : ''" id="street"
                v-validate="'required'" v-bind:error="errors.first('city_id')" data-vv-name="city_id" v-bind:data-vv-as="' '"
            ></z-input-autocomplete>

            <z-input-autocomplete
                v-if="price.by == 'steet'" v-model="price.street" v-on:select="selectSteet"
                property="value" return="id" label="Улица" display-property="label" name="street" id="street"
                v-bind:callback="getStreets" v-bind:default="(price.steet && price.steet.name) ? price.steet.name : ''"
                v-validate="'required'" v-bind:error="errors.first('street')" data-vv-name="street" v-bind:data-vv-as="' '"
            ></z-input-autocomplete>

            <z-select
                label="Тип расчёта" v-model="price.type" :required="true" name="type" id="type"
                v-validate="'required'" v-bind:data-vv-as="' '" v-bind:error="errors.first('type')"
            >
                <option value="" selected disabled> Выбрать... </option>
                <option v-bind:value="1"> По весу </option>
                <option v-bind:value="2"> По объёму </option>
            </z-select>
            <div class="row">
                <z-input
                    v-model="price.value_min" v-bind:label="(parseInt(price.type) == 1) ? 'Минимальный вес' : 'Минимальный объём'" name="value_min" id="value_min" class="col-4" data-vv-name="value_min" v-bind:data-vv-as="' '"
                    v-validate="{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}" v-bind:required="true" v-bind:error="errors.first('value_min')" type="number"
                ></z-input>

                <z-input
                    v-model="price.value_max" v-bind:label="(parseInt(price.type) == 1) ? 'Максимальный вес' : 'Максимальный объём'" name="value_max" id="value_max" class="col-4" data-vv-name="value_max" v-bind:data-vv-as="' '"
                    v-validate="{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}" v-bind:required="true" v-bind:error="errors.first('value_max')" type="number"
                ></z-input>

                <z-input
                    v-model="price.price" label="Стоимость" name="price" id="price" class="col-4" data-vv-name="price" v-bind:data-vv-as="' '"
                    v-validate="{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" v-bind:required="true" v-bind:error="errors.first('price')" type="number"
                ></z-input>
            </div>
        </div>
    </entity-page>
</template>
<script>
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: {ZInputAutocomplete, ZInput, ZSelect, EntityPage, ZIconButton},
        data() {
            return {
                price: {},
                priceDefault: {
                    id: null,
                    by: '',
                    type: '',
                    city_id: null,
                    city: null,
                    street: null,
                    street_value: null,
                    street_object: null,
                    value_min: 0,
                    value_max: 0,
                    price: 0
                },
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-price-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        created() {
            this.init();
        },
        methods: {
            /**
             * Возврат на предидущую страницу
             */
            back() {
                this.$router.push({name: 'ForwardingPrices', query: this.$route.query});
            },
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('setTitle', 'Цена экспедирования');
                this.$store.commit('openRightPanel');
                if (this.$route.params.price_id && this.$route.params.price_id != 'new') this.getPrice(this.$route.params.price_id).then(price => {
                    this.price = Object.assign({}, price);
                    this.price.by = price.street ? 'street' : 'city';
                }); 
                else {
                    this.price = Object.assign({}, this.priceDefault);

                    if (this.$route.query && this.$route.query.clone_id) {
                        this.getPrice(this.$route.query.clone_id).then(price => {
                            this.price = Object.assign({}, price);
                            this.price.by = price.street ? 'street' : 'city';
                        });
                    }
                }
            },
            /**
             * Получение цены
             */
            getPrice(id) {
                this.$store.commit('showProgressBar', 'load-price-card');
                return this.$store.dispatch('cost/getForwardingPrice', { id: id })
                    .finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Сохранение
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.price_id != 'new') this.putPrice();
                    else this.postPrice();
                })
            },
            /**
             * Добавление цены
             */
            postPrice() {
                this.$store.commit('showProgressBar', 'load-price-card');
                this.$store.dispatch('cost/addForwardingPrice', {price: this.price}).then(r => {
                    if (!r) return;
                    this.$router.push({name: 'ForwardingPrice', params: {price_id: r.id}});
                    this.$root.$emit('reload-table', 'forwardingprices')
                }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Изменение цены
             */
            putPrice() {
                this.$store.commit('showProgressBar', 'load-price-card');
                this.$store.dispatch('cost/updateForwardingPrice', {price: this.price}).then(r => {
                    if (!r) return;
                    this.getPrice(r.id);
                    this.$root.$emit('reload-table', 'forwardingprices')
                }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Подставление города
             */
            getCities(searchString) {
                if (searchString.length >= 3) return this.$store.dispatch('cost/getCities', {
                    page: 1, count: 10,
                    filter: {model: [['name', '%', searchString], 'or', ['value', '%', searchString]]} 
                }).then( async r => {
                    if (!r || !r.length) r = [];

                    r.map(item => Object.assign(item, {
                        value: item.value || item.name,
                        label: item.value || item.name
                    }));

                    return r.concat(await this.suggestCity(searchString, r.map(item => item.name)))
                });
            },
            /**
             * Предложение города
             */
            suggestCity(searchString, existsNames) {
                return this.$store.dispatch('cost/suggestCity', { string: searchString }).then(r => {
                    if (!r || !r.length) return [];
                    return r.filter(item => item && item.unrestricted_value && !item.data.street)
                        .filter(item => item.data.city || item.data.settlement)
                        .filter(item => !!item.unrestricted_value)
                        .map(item => {
                            return {
                                name:    item.data.settlement ? (item.data.settlement + ' ' + item.data.settlement_type) : (item.data.city + ' ' + item.data.city_type),
                                aouguid: item.data.settlement_fias_id ? item.data.settlement_fias_id : item.data.city_fias_id,
                                okato:   item.data.okato,
                                parentguid: (item.data.region_fias_id) ? item.data.region_fias_id : null,
                                disid:   null,
                                zone_id: null,
                                zone_id: null,
                                label: item.unrestricted_value ? item.unrestricted_value : '',
                                value: item.unrestricted_value ? item.unrestricted_value : '',
                                sort: 100
                            };
                        }).filter(item => item.value && item.label).filter(item => (!(existsNames.indexOf(item.name)+1)));
                });
            },
            /**
             * Добавление города
             */
            addCity(city) {
                this.$store.commit('showProgressBar', 'load-price-card');
                city.suggest = true;
                return this.$store.dispatch('cost/addCity', { city: city })
                    .finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Выбор города
             */
            async selectCity(id, city) {
                if (!id || id == 'new') city = await this.addCity(city);
                if (!city || !city.id) return;
                
                this.price.city_id = city.id;
                this.price.city = Object.assign({}, city);   
            },
            /**
             * Подставление улицы
             */
            getStreets(searchString) {
                if (searchString.length < 3 || !this.price || !this.price.city || !this.price.city.aoguid) return new Promise(resolve => resolve([]));
                return this.$store.dispatch('cost/suggestStreet', {
                    string: searchString,
                    locations: [{
                        city_fias_id: this.price.city.aoguid
                    }]
                }).then(r => {
                    if (!r || !r.length) return [];
                    return r.filter(item => item.data.street_type != 'пл') //Убираем из подсказок площади
                    .map(item => {
                        return {
                            id: item.data.street_fias_id,
                            value: item.data.street_with_type,
                            label: item.data.street_with_type
                        }
                    });
                });
            },
            /**
             * Выбор улицы
             */
            selectSteet(id, street) {
                if (street && street.value) this.price.street_value = street.value;
            },
            /**
             * Сброс города/улицы
             */
            resetType() {
                this.price.city_id = null,
                this.price.city = null,
                this.price.street = null,
                this.price.street_value = null,
                this.price.street_object = null
            }
        },
        watch: {
            '$route.params.price_id'() {
                this.init();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ForwardingPrice.vue?0004424b